<template>
  <p :class="getClass()">{{ this.policyType | translate }}</p>
</template>

<script>
export default {
  name: 'PolicyTypeBadge',
  props: {
    policyType: String
  },
  methods: {
    getClass () {
      if (this.policyType === 'WIA') return 'policy-type-badge wia';
      else if (this.policyType === 'VZM') return 'policy-type-badge vzm';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';

.policy-type-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: $border-radius;
  font-weight: 600;
  font-size: 0.9em;

  &.wia {
    background-color: $secondary-lighten-3;
    color: $secondary;
  }

  &.vzm {
    background-color: $tertiary-lighten-2;
    color: $tertiary-darken-1;
  }
}

</style>
